import { Validator } from './validator';

export class QuantityValidator implements Validator {

    validate(validationContext: any): Promise<boolean> {
        const quantityInput = document.querySelector(`#df_${validationContext.id}_quantity`) as HTMLSelectElement;
        const isValid = Number(quantityInput.value) > 0;
        return Promise.resolve(isValid);
    }

}
